"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductType = void 0;
var ProductType;
(function (ProductType) {
    ProductType["Experience"] = "experience";
    ProductType["Box"] = "box";
    ProductType["ValueVoucher"] = "value_voucher";
    ProductType["GiftWrap"] = "gift_wrap";
})(ProductType || (exports.ProductType = ProductType = {}));
//# sourceMappingURL=ProductType.js.map